"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeeklyColumns = void 0;
require("../types");
const getWeeklyColumns = (texts) => [
    { title: texts.sunday },
    { title: texts.monday },
    { title: texts.tuesday },
    { title: texts.wednesday },
    { title: texts.thursday },
    { title: texts.friday },
    { title: texts.saturday },
];
exports.getWeeklyColumns = getWeeklyColumns;
//# sourceMappingURL=getWeeklyColumns.js.map